/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_TabsInputs */



/**
* | output |
* | --- |
* | "Which practice conversations" |
*
* @param {Practice_TabsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_tabs = /** @type {((inputs?: Practice_TabsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_TabsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Welke oefengesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quels entretiens d'entraînement")
	return /** @type {LocalizedString} */ ("Which practice conversations")
});